import {
  LcgClassifyModeSchema,
  LcgProductScopeSchema,
} from "@redotech/redo-model/landed-cost/landed-cost-settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const triggerLcgClassify = {
  name: "triggerLcgClassify" as const,
  input: z.object({
    teamId: zExt.objectId(),
    classifyMode: LcgClassifyModeSchema,
    productScope: LcgProductScopeSchema,
    maxClassifications: z.number().positive().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    workflowId: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
